import { render, staticRenderFns } from "./couponDetail.vue?vue&type=template&id=174c7e79"
import script from "./couponDetail.vue?vue&type=script&lang=js"
export * from "./couponDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports